module.exports = __webpack_public_path__ + "img/home_bottom.10c55225.png";